package com.swetdot.swetgram.domain

data class NotificationPreferences(
    val messages: Boolean,
    val groups: Boolean,
    val discover: Boolean,
    val mentions: Boolean,
    val security: Boolean,
    val showMessagePreview: Boolean,
    val showDiscoverCommentPreview: Boolean,
    val mutedChatMentions: Boolean,
    val streaks: Boolean = true,
)
